module.exports = __webpack_public_path__ + "img/CC-3-way-Split.fbc05d96.png";